<template>
  <div class="vl-person-publish">
    <div class="invariable">
      <div class="stepTitle">
        <span>申请上线</span> <br />
        <span>APPLICATION ONLINE</span>
      </div>
    </div>
    <div class="process">
      <ul>
        <li
          :class="{
            atPresent: active == index,
            EXIST: index < active || active == stepList.length - 1,
          }"
          v-for="(item, index) in stepList"
          :key="index"
        >
          <i>{{ index + 1 }}</i>
          <span>{{ item.name }}</span>
        </li>
      </ul>

      <el-form
        ref="form"
        :model="formInline"
        label-width="180px"
        style="width: 80%; margin: 30px auto 0"
        :rules="rules"
      >
        <el-form-item label="应用名称：" v-if="active == 0">
          <span>{{ formInline.appName || "" }}</span>
        </el-form-item>
        <el-form-item
          key="appLogo"
          label="应用logo："
          v-if="active == 0"
          prop="appLogo"
        >
          <el-upload
            accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
            :before-upload="beforeAvatarUpload"
            class="avatar-uploader"
            :action="actionUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <img
              ref="appLogo"
              v-if="formInline.appLogo"
              :src="formInline.appLogo"
              class="avatar"
            />
            <i class="el-icon-plus avatar-uploader-icon" v-else>
              <span class="avatarText">上传图标</span>
            </i>
          </el-upload>
        </el-form-item>
        <el-form-item label="应用分类：" v-if="active == 0" prop="appTypeName">
          <el-input
            v-model="formInline.appTypeName"
            disabled
            placeholder="请输入应用分类"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="适用对象："
          v-if="active == 0"
          prop="accountTypeName"
        >
          <el-checkbox-group disabled v-model="formInline.accountTypeName">
            <el-checkbox label="机构人员"></el-checkbox>
            <el-checkbox label="学生"></el-checkbox>
            <el-checkbox label="家长"></el-checkbox>
            <el-checkbox label="老师"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="适用学段："
          v-if="active == 0"
          prop="periodTypeName"
        >
          <el-checkbox-group disabled v-model="formInline.periodTypeName">
            <el-checkbox label="幼儿园"></el-checkbox>
            <el-checkbox label="小学"></el-checkbox>
            <el-checkbox label="初中"></el-checkbox>
            <el-checkbox label="高中"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="应用宣传语："
          v-if="active == 0"
          prop="appPublicity"
        >
          <el-input
            class="dispose"
            maxlength="60"
            auto-complete="on"
            v-model="formInline.appPublicity"
            placeholder="请输入应用宣传语"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="应用描述语："
          v-if="active == 0"
          prop="appDescribe"
        >
          <el-input
            auto-complete="on"
            maxlength="500"
            v-model="formInline.appDescribe"
            placeholder="请输入应用描述语"
            type="textarea"
            :rows="4"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="应用终端类型："
          v-if="active == 0"
          prop="appTerminalTypeName"
        >
          <el-radio-group disabled v-model="formInline.appTerminalTypeName">
            <el-radio label="Web网页" style="margin-bottom: 20px"></el-radio>
            <el-radio label="H5网页" style="margin-bottom: 20px"></el-radio>
            <el-radio
              label="Android手机应用"
              style="margin-bottom: 20px"
            ></el-radio>
            <el-radio
              label="IOS手机应用"
              style="margin-bottom: 20px"
            ></el-radio>
            <el-radio
              label="IOS平板应用"
              style="margin-bottom: 20px"
            ></el-radio>
            <el-radio
              label="Android平板应用"
              style="margin-bottom: 20px"
            ></el-radio>
            <el-radio label="PC客户端"></el-radio>
            <el-radio label="后端服务"></el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item
          class="pwdInput"
          label="接入级别："
          v-if="active == 0"
          prop="joinRankName"
        >
          <el-select
            v-model="formInline.joinRankName"
            disabled
            placeholder="请选择接入级别"
            style="width: 100%"
          >
          </el-select>
        </el-form-item> -->
        <el-form-item label="应用版本：" v-if="active == 0" prop="appVersion">
          <el-input
            class="dispose"
            auto-complete="on"
            maxlength="30"
            v-model="formInline.appVersion"
            placeholder="请输入应用版本"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="版本说明："
          v-if="active == 0"
          prop="appVersionExplain"
        >
          <el-input
            class="dispose"
            auto-complete="on"
            maxlength="500"
            v-model="formInline.appVersionExplain"
            placeholder="请输入版本说明，不超过500字"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item :label="visitUrlName" v-if="active == 0" prop="visitUrl">
          <el-input
            class="dispose"
            auto-complete="on"
            v-model="formInline.visitUrl"
            placeholder="请输入正确的网络地址，必须以https://开头，不多于500字"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          key="testReport"
          ref="reportUpload"
          class="red-star"
          label="测试报告："
          v-if="active == 0"
          prop="testReport"
        >
          <el-upload
            :action="actionUrl"
            :before-upload="beforeAvatarUpload"
            :on-change="getValChange"
            :on-success="handleChange"
            :file-list="fileList"
            :on-remove="fileRemove"
          >
            <span class="blueFont">上传</span>
          </el-upload>
        </el-form-item>
        <el-form-item
          key="formScreen"
          label="应用截屏："
          v-if="active == 0"
          prop="appScreenshotArray"
          ref="uploadElement"
        >
          <span>（jpg,png,jpeg,bmp,gif，1MB以内，5张以内）</span>
          <el-upload
            :on-exceed="handleExceed"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
            :before-upload="beforeAvatarUpload"
            :limit="5"
            class="upload-demo"
            :action="actionBatchUrl"
            list-type="picture-card"
            :on-success="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="screenArr"
            :on-change="pictureCardChange"
          >
            <i class="el-icon-plus">
              <span class="avatarText">上传应用截屏</span>
            </i>
          </el-upload>
        </el-form-item>

        <el-form-item label="姓名：" v-if="active == 1" prop="appContacts">
          <el-input
            class="dispose"
            maxlength="30"
            v-model="formInline.appContacts"
            placeholder="请输入姓名"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="手机号码："
          v-if="active == 1"
          prop="appContactsPhone"
        >
          <el-input
            class="dispose"
            v-model="formInline.appContactsPhone"
            maxlength="11"
            placeholder="请输入手机号码"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="座机号码："
          v-if="active == 1"
          prop="landlinePhone"
        >
          <el-input
            class="dispose"
            auto-complete="on"
            maxlength="30"
            v-model="formInline.landlinePhone"
            placeholder="请输入座机号码"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="电子邮箱："
          key="appContactsEmail"
          v-if="active == 1"
          prop="appContactsEmail"
        >
          <el-input
            class="dispose"
            maxlength="60"
            v-model="formInline.appContactsEmail"
            placeholder="请输入电子邮箱"
          >
          </el-input>
        </el-form-item>

        <div v-if="active == 2" class="accomplish">
          <img
            src="../../../../assets/img/personalCenter/accomplish.png"
            alt=""
          />
          <p>提交成功，请等待审核…</p>
        </div>

        <el-form-item>
          <el-button type="primary" v-if="active == 0" @click="next('form')"
            >下一步</el-button
          >
          <el-button v-if="active == 0" @click="goAppList">取消</el-button>

          <el-button type="primary" v-if="active == 1" @click="next('form')"
            >提交审核</el-button
          >
          <el-button v-if="active == 1" @click="goUp">上一步</el-button>

          <el-button type="primary" v-if="active == 2" @click="seeDetail"
            >查看应用详情</el-button
          >
          <el-button v-if="active == 2" @click="goAppList"
            >返回应用列表</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  PersonalPostAppInfoById,
  PersonalPostOnlineAppApply,
} from "@/views/index/api/personalCenter/api.personalCenter.js";
import { ajaxCtx } from "@/config/config.js";
export default {
  data() {
    let reg =
      /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
    var validateComfirmPwd = (rule, value, callback) => {
      if (!reg.test(value)) {
        callback(new Error("请输入正确的邮箱地址"));
      } else {
        callback();
      }
    };

    const validateVisitUrl = (rule, value, callback) => {
      if (new RegExp("^https://.*$").test(value) && value.length <= 500) {
        callback();
      } else {
        if (!new RegExp("^https://.*$").test(value)) {
          callback(new Error("地址必须以https://开头"));
        } else if (value.length > 500) {
          callback(new Error("地址超过500字，请缩减地址长度。"));
        }
      }
    };

    const reportIsEnter = (rule, value, callback) => {
      if (this.active == 0 && !this.formInline.testReport) {
        callback(new Error("请上传测试报告"));
      } else if (this.active == 0 && this.formInline.testReport) {
        callback();
      }
    };

    const isEntrust = (rule, value, callback) => {
      if (this.active == 0 && this.formInline.appScreenshotArray.length == 0) {
        return callback(new Error("请上传应用截屏"));
      } else if (
        this.active == 0 &&
        this.formInline.appScreenshotArray.length > 0
      ) {
        return callback();
      }
    };
    return {
      appId: null,
      actionUrl: ajaxCtx.base + "file/upload",
      actionBatchUrl: ajaxCtx.base + "file/batch",
      screenArr: [],
      fileList: [],
      stepList: [
        {
          name: "填写应用信息",
        },
        {
          name: "填写服务信息",
        },
        {
          name: "完成",
        },
      ],
      visitUrlName: "下载地址：",
      active: 0,
      formInline: {
        appLogo: null,
        appTypeName: null,
        accountTypeName: [],
        periodTypeName: [],
        appPublicity: null,
        appDescribe: null,
        appTerminalTypeName: null,
        joinRankName: null,
        appVersion: null,
        appVersionExplain: null,
        visitUrl: null,
        testReport: null,
        appScreenshotArray: [],
        appContacts: null,
        appContactsPhone: null,
        landlinePhone: null,
        appContactsEmail: "",
      },
      rules: {
        appScreenshotArray: [
          { required: true, message: "请上传应用截屏", trigger: "change" },
          { type: "array", validator: isEntrust, trigger: "change" },
        ],
        appContactsEmail: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { validator: validateComfirmPwd, trigger: "change" },
          {
            pattern:
              /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
            message: "请输入正确的邮箱地址",
            trigger: "change",
          },
        ],
        appContacts: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            pattern: /^(?:[\u4e00-\u9fa5]{2,30})$/,
            message: "请输入正确的姓名",
            trigger: "change",
          },
        ],
        appContactsPhone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "change",
          },
        ],
        appLogo: [
          { required: true, message: "请上传应用logo", trigger: "change" },
        ],
        appTypeName: [
          { required: true, message: "请选择应用分类", trigger: "change" },
        ],
        appDescribe: [
          { required: true, message: "请输入应用描述语", trigger: "blur" },
        ],
        joinRankName: [
          { required: true, message: "请选择接入级别", trigger: "change" },
        ],
        appVersion: [
          { required: true, message: "请输入应用版本", trigger: "blur" },
        ],
        visitUrl: [
          {
            required: true,
            message: "请输入正确的网络地址",
            trigger: "blur",
          },
          { validator: validateVisitUrl, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.appId = this.$route.query.appId;
    this.getAppData();
  },
  methods: {
    // 返回应用列表
    goAppList() {
      this.$router.push({ name: "personDefault" });
    },
    // 查看详情
    seeDetail() {
      this.$router.push({
        name: "appManegeAppDetail",
        query: { appId: this.appId },
      });
    },
    // 上一步
    goUp() {
      this.active = 0;
    },
    // 测试报告上传文件处理
    handleChange(file) {
      this.formInline.testReportName = file.result.fileName;
      this.formInline.testReport = file.result.accessUrl;
      this.fileList = [
        {
          name: this.formInline.testReportName,
          url: this.formInline.testReport,
        },
      ];
      this.$nextTick(() => {
        this.$refs["form"].clearValidate(["testReport"]);
        this.$forceUpdate();
      });
    },
    getValChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      } else {
        this.fileList = fileList[0];
      }
    },
    // 下一步 提交审核
    next() {
      if (
        this.fileList.length == 0 &&
        this.formInline.appScreenshotArray.length == 0
      ) {
        this.$MyMessage("请将信息填写完整", 'error');
        return;
      }
      if (this.active == 0 && !this.formInline.testReport) {
        this.$MyMessage("请上传测试报告", 'error');
        return;
      }
      if (this.active == 0) {
        this.$forceUpdate();
        if (this.fileList.length > 1) {
          this.$refs.form.clearValidate(["testReport"]);
        } else {
          this.$refs.form.validateField("testReport");
        }
        if (this.formInline.appScreenshotArray.length > 0) {
          this.$refs.form.clearValidate(["appScreenshotArray"]);
        } else {
          this.$refs.form.validateField("appScreenshotArray");
        }
      }
      this.$refs["form"].validate((valid) => {
        let arr = [];
        if (this.formInline.appScreenshotArray.length > 0) {
          this.formInline.appScreenshotArray.map((el) => {
            arr.push(el.url ? el.url : el);
          });
        }
        let obj = {
          accountType: this.formInline.accountType,
          appDescribe: this.formInline.appDescribe,
          appId: this.appId,
          appLogo: this.formInline.appLogo,
          appPublicity: this.formInline.appPublicity,
          appScreenshots: arr.join(","),
          appType: this.formInline.appType,
          appVersion: this.formInline.appVersion,
          appVersionExplain: this.formInline.appVersionExplain,
          periodType: this.formInline.periodType,
          testReport: this.formInline.testReport,
          testReportName: this.formInline.testReportName,
          visitUrl: this.formInline.visitUrl,
          appContacts: this.formInline.appContacts,
          appContactsEmail: this.formInline.appContactsEmail,
          appContactsPhone: this.formInline.appContactsPhone,
          landlinePhone: this.formInline.landlinePhone,
        };

        if (valid) {
          this.active += 1;
          if (this.active == 2) {
            PersonalPostOnlineAppApply(obj);
          }
        }
      });
    },
    // 获取数据
    getAppData() {
      let params = {
        appId: this.appId,
      };
      PersonalPostAppInfoById(params).then((res) => {
        this.visitUrlName = "下载地址：";
        if (res && res.result) {
          this.formInline = res.result;
          if (
            res.result.appTerminalType == "app_terminal_type_1" ||
            res.result.appTerminalType == "app_terminal_type_2" ||
            res.result.appTerminalType == "app_terminal_type_8"
          ) {
            this.visitUrlName = "访问路径：";
          }
          this.formInline.accountTypeName =
            this.formInline.accountTypeName.split(",");
          this.formInline.periodTypeName =
            this.formInline.periodTypeName.split(",");
          this.screenArr = [];
          let arr = [];
          if (
            this.formInline.appScreenshotArray &&
            this.formInline.appScreenshotArray.length > 0
          ) {
            this.formInline.appScreenshotArray.map((el, index) => {
              this.screenArr.push({
                name: "截图" + index + 1,
                url: el,
              });
              arr.push(el);
            });
            this.formInline.appScreenshotArray = arr;
          } else {
            this.formInline.appScreenshotArray = [];
          }
          if (this.formInline.testReport) {
            this.fileList = [];
            this.fileList.push({
              name: this.formInline.testReportName,
              url: this.formInline.testReport,
            });
          }
          if (this.formInline.appStatus == "app_status_7") {
            this.$message({
              type: "error",
              dangerouslyUseHTMLString: true,
              message:
                '<div style="margin-bottom:5px;">驳回理由： </div><span>' +
                this.formInline.rejectReason +
                "</span>",
            });
          }
        }
      });
    },
    // 截图文件移除
    handleRemove(file, fileList) {
      this.screenArr = fileList;
      this.formInline.appScreenshotArray = this.screenArr;
      if (this.formInline.appScreenshotArray.length == 0) {
        this.formInline.appScreenshotArray = [];
        this.$refs.form.validateField("appScreenshotArray");
        this.$forceUpdate();
      }
    },
    // 截图超出5张
    handleExceed(files, fileList) {
      this.$message.warning(`已选择了 ${fileList.length} 个文件`);
    },
    // 测试报告移除
    fileRemove(file, fileList) {
      this.$nextTick(() => {
        this.fileList = fileList;
        this.formInline.testReportName = null;
        this.formInline.testReport = null;
      });
      this.$refs.form.validateField("testReport");
      this.$forceUpdate();
    },
    // 应用截图
    handlePictureCardPreview(res) {
      if (res.code != "00000") {
        this.$message.error("截图上传失败，请重新上传");
        return;
      } else {
        // let arr = []
        res.result.map((el) => {
          this.formInline.appScreenshotArray.push(el.accessUrl);
        });
        // this.formInline.appScreenshotArray = arr;
        this.$nextTick(() => {
          this.$refs["form"].clearValidate(["appScreenshotArray"]);
          this.$forceUpdate();
        });
      }
    },
    pictureCardChange(file, fileList) {
      this.screenArr = fileList;
      this.screenArr.map((el) => {
        if (el.response) {
          el.url = el.response.result[0].accessUrl;
        }
      });
    },
    handleAvatarSuccess(res) {
      this.$set(this.formInline, "appLogo", res.result.accessUrl);
      this.$refs.form.validateField("appLogo");
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.error("上传的文件不能超过 1MB!");
      }
      return isLt2M;
    },
  },
};
</script>
<style lang="scss" scoped>
.vl-person-publish {
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  margin-top: 20px;
  min-height: 857px;
  .blueFont {
    color: #4286f5;
  }
  .invariable {
    height: 200px;
    background: url(../../../../assets/img/activeAccount/setting.png) no-repeat
      center;
    background-size: 100% 100%;
    position: relative;
  }
  .invariable > .stepTitle {
    font-size: 24px;
    color: #a7ccf2;
    font-weight: bold;
    position: absolute;
    top: 70px;
    left: 220px;
    line-height: 35px !important;
  }
  .invariable > .stepTitle > span:first-child {
    color: #3f7bbb;
  }
  .process > h3 {
    font-size: 24px;
    color: #0ecad6;
    text-align: center;
    padding-bottom: 30px;
  }
  .process > .setting {
    text-align: center;
    color: #999999;
    margin-bottom: 20px;
  }
  .process > .setting > span {
    color: #333;
  }
  .process {
    width: 800px;
    margin: 0 auto;
  }
  .process > ul {
    display: flex;
    background: #f1f7ff;
  }
  .process > ul > li {
    flex: 1;
    padding: 17px 0;
    text-align: center;
    font-size: 18px;
    color: #999999;
  }
  .process > ul > li.atPresent {
    background: url(../../../../assets/img/personalCenter/articleSteps.png)
      no-repeat center;
    background-size: 100% 100%;
    color: #4286f5;
  }

  .process > ul > li > i {
    display: inline-block;
    width: 26px;
    height: 26px;
    border: 1px solid #999999;
    border-radius: 50%;
    margin-right: 10px;
  }
  .process > ul > li.atPresent > i,
  .process > ul > li.EXIST > i {
    background: #4286f5;
    border: 1px solid #4286f5;
    color: #fff;
  }
  .process > ul > li.EXIST {
    color: #4286f5;
    background-color: #e4f1ff;
  }

  .process .el-button--primary {
    font-size: 14px;
    padding: 12px 24px !important;
  }
  .process .el-input__suffix {
    top: 8px !important;
    right: 15px !important;
  }
  .process .el-button--default {
    border: 1px solid #4286F5;
    color: #4286F5;
    &:hover {
      background-color: #4286F5;
      color: #fff;
    }
  }
  .process .el-input__suffix .el-input__suffix-inner {
    border-left: 1px solid #dcdfe6;
    padding-left: 15px !important;
    cursor: pointer;
  }
  .accomplish {
    text-align: center;
    margin-bottom: 30px;
  }
  .accomplish > img {
    margin-top: 60px;
    display: inline-block;
  }
  .accomplish > p {
    padding-top: 20px;
    font-size: 24px;
    font-weight: bold;
    color: #4286f5;
  }
  /deep/.avatar-uploader .el-upload,
  /deep/.el-upload--picture-card {
    background: #f5f7fa;
    border-radius: 4px !important;
    border: 1px solid #dcdfe6 !important;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/.avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  /deep/.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 180px;
    height: 180px;
    text-align: center;
    line-height: 145px !important;
  }
  .avatar {
    width: 180px;
    height: 180px;
    display: block;
  }
  .avatarText {
    font-size: 16px;
    color: #909399;
    position: absolute;
    top: 30px;
    left: 60px;
  }
  /deep/.el-upload--picture-card {
    width: 115px !important;
    height: 115px !important;
    line-height: 90px !important;
    position: relative;
  }
  /deep/.el-upload--picture-card i {
    font-size: 14px !important;
  }
  /deep/.el-upload--picture-card .avatarText {
    font-size: 14px !important;
    top: 60px !important;
    display: inline-block;
    width: 90px;
    left: 15px !important;
  }
  /deep/.upload-demo .el-upload-list__item {
    width: 115px !important;
    height: 115px !important;
  }
}
</style>
<style lang="scss">
  .red-star {
    .el-form-item__label {
      &:before {
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
      }
    }
  }
</style>